
import type { ConflictApiError } from '@empathyco/playboard-core-domain'
import type { PropType, SetupContext } from 'vue'
import type { ConflictErrorModalMessages } from '../../../models/i18n/tools.messages'
import { computed, defineComponent, ref } from 'vue'
import { ResolveConflictOption } from '../../../models/components/resolve-conflict-option'
import { UiConfirm, UiRadioGroup } from '../../keen-ui'
import ConflictErrorList from './conflict-error-list.component.vue'
import { useConflictErrors } from './use-conflict-errors'

export default defineComponent({
  name: 'ConflictErrorModalWithOptions',
  components: {
    ConflictErrorList,
    UiConfirm,
    UiRadioGroup,
  },
  props: {
    conflictApiError: {
      type: Object as PropType<ConflictApiError>,
      default: undefined,
    },
    messages: {
      type: Object as PropType<ConflictErrorModalMessages['dialog']>,
      required: true,
    },
    itemQueries: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    updateRouteName: {
      type: String,
      default: undefined,
    },
  },
  setup: (props, ctx: SetupContext) => {
    const { emit } = ctx
    const uiConfirm = ref()
    const resolveConflictOptions = [
      {
        value: ResolveConflictOption.DISABLE_PREVIOUS,
        label: props.messages.options.disablePrevious,
      },
      {
        value: ResolveConflictOption.DISABLE_CURRENT,
        label: props.messages.options.disableActual,
      },
    ]

    const resolveConflictValue = ref(resolveConflictOptions[0].value)

    function onConfirm(): void {
      emit('confirm', resolveConflictValue.value)
    }

    const { conflicts } = useConflictErrors(props)

    const modalTitle = computed(() => {
      return props.conflictApiError?.title || props.messages.title
    })

    const modalContent = computed(() => {
      return props.conflictApiError?.message || props.messages.content
    })

    function open(): void {
      uiConfirm.value.open()
    }

    return {
      baseClass: 'conflict-error-modal-with-options',
      conflicts,
      modalTitle,
      modalContent,
      onConfirm,
      open,
      resolveConflictOptions,
      resolveConflictValue,
      uiConfirm,
    }
  },
})
